function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import ChevronDownIcon from 'svg/chevron-down.svg';
import ChevronUpIcon from 'svg/chevron-up.svg';
import ChevronsHorizontalIcon from 'svg/chevrons-horizontal.svg';
import styles from './SortingIcon.pcss';
var _React_PureComponent;
class SortingIcon extends (_React_PureComponent = React.PureComponent) {
    get icon() {
        const classNameValue = this.props.className || '';
        switch(this.props.type){
            case 'default':
                {
                    return /*#__PURE__*/ _jsx(ChevronsHorizontalIcon, {
                        className: cn(styles.box__icon, classNameValue)
                    });
                }
            case 'asc':
                {
                    return /*#__PURE__*/ _jsx(ChevronUpIcon, {
                        className: cn(styles.box__icon, classNameValue)
                    });
                }
            case 'desc':
                {
                    return /*#__PURE__*/ _jsx(ChevronDownIcon, {
                        className: cn(styles.box__icon, classNameValue)
                    });
                }
            default:
                return null;
        }
    }
    render() {
        const { icon } = this;
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: icon
        });
    }
}
_define_property(SortingIcon, "propTypes", {
    type: PropTypes.oneOf([
        'default',
        'asc',
        'desc'
    ]),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
});
export default withStyles(styles)(SortingIcon);
